import React, { useState, useRef, useEffect } from 'react';
import NoteForm from './NoteForm';
import { ListOfNotes, scrollNotesView } from './listOfNotes';
import { retrieveUserData } from '../../supplementary_components/userDataDelegate';
import styles from './noteManaging.module.scss';

// notesArray={pageObject.notes} category={category} itemId={pageObject.id} requestReload={requestReload}
export const NoteManagingComponent = ({ notesArray, category, itemId, fullScreen, fillParent, popup, subjectsToAddNote }) => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const componentHeight = Math.min(vw, vh) - (12 * parseFloat(getComputedStyle(document.documentElement).fontSize));

    const currentUser = retrieveUserData();
    const [, setNotesFormHeight] = useState(16);
    const NotesViewRef = useRef(null);
    const scrollNeededRef = useRef(true);

    const [notes, setNotes] = useState(notesArray);
    const _setNotes = (data) => {
        setNotes(data);
    };

    const isItemPageLayout = !fillParent && !fullScreen;

    const frameClassName = [
        styles.frame,
        fillParent && styles.frameFillParent,
        fullScreen && !fillParent && styles.frameFullScreen,
        isItemPageLayout && styles.frameItemPage,
    ].filter(Boolean).join(' ');

    const frameStyle = isItemPageLayout ? { height: componentHeight } : undefined;

    const notesViewClassName = [
        styles.notesView,
        fillParent && styles.notesViewFillParent,
    ].filter(Boolean).join(' ');

    useEffect(() => {
        setNotes((prev) => {
            const next = convertNotesToArray(notesArray);
            const prevArr = Array.isArray(prev) ? prev : [];
            if (areNotesEquivalent(prevArr, next)) return prevArr;
            return next;
        });
    // eslint-disable-next-line
    }, [notesArray]);

    useEffect(() => {
        if (!scrollNeededRef.current) return;
        scrollNeededRef.current = false;
        scrollNotesView(document.getElementById('notesView'));
    }, [notes]);

    return (
        <div className={frameClassName} style={frameStyle}>
            <div ref={NotesViewRef} id="notesView" className={notesViewClassName}>
                <ListOfNotes currentUser={currentUser} notes={notes} setNotes={_setNotes} category={category} itemId={itemId} />
            </div>
            <NoteForm
                currentUser={currentUser}
                objectType={category}
                objectId={itemId}
                setNotes={_setNotes}
                setNotesFormHeight={setNotesFormHeight}
                setScrollNeeded={(val) => { scrollNeededRef.current = Boolean(val); }}
                subjectsToAddNote={subjectsToAddNote}
                popup={popup}
            />
        </div>
    );
};

export const convertNotesToArray = (arr) => {
    if (arr && Array.isArray(arr) && arr.length > 0 && typeof arr[0] === 'object') {
        return arr;
    }
    let arrayOfNotes = [];
    arr?.forEach((note) => {
        arrayOfNotes.push(JSON.parse(note));
    });
    return arrayOfNotes;
};

function areNotesEquivalent(a, b) {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        const x = a[i];
        const y = b[i];
        if ((x?.id ?? null) !== (y?.id ?? null)) return false;
        if ((x?.urgent ?? null) !== (y?.urgent ?? null)) return false;
        if ((x?.relevant ?? null) !== (y?.relevant ?? null)) return false;
        if ((x?.noteMessage ?? null) !== (y?.noteMessage ?? null)) return false;
        if ((x?.lastChangedTime ?? null) !== (y?.lastChangedTime ?? null)) return false;
    }
    return true;
}
